export const PLAYER_TYPES = {
  BRIGHTCOVE: 'brightcove',
  SHAKA: 'shaka',
};

export const DATAZOOM_CONFIG_ID_BRIGHTCOVE = process.env.DATAZOOM_CONFIG_ID_BRIGHTCOVE || '';
export const DATAZOOM_CONFIG_ID_SHAKA = process.env.DATAZOOM_CONFIG_ID_SHAKA || '';
